// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDNkoWczwKP07xz6SwO1TbLniL9Sf8yJBI",
  authDomain: "btpms-d214d.firebaseapp.com",
  databaseURL: "https://btpms-d214d-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "btpms-d214d",
  storageBucket: "btpms-d214d.firebasestorage.app",
  messagingSenderId: "556196332480",
  appId: "1:556196332480:web:8d658c425045563df97e25"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export default db;
